import './NPTag.css'

export function NPTag({ text }) {

    return (
        <span className="np-tag">
            {text}
        </span>
    )
}